{
  "backgroundColor": "transparent",
  "tooltip": {
    "trigger": "item",
    "formatter": "{a} <br/>{b}: {c} ({d}%)"
  },
  "series": [
    {
      "name": "Access From",
      "type": "pie",
      "radius": ["40%", "90%"],
      "padAngle": 1,
      "labelLine": {
        "show": false
      },
      "label": {
        "position": "inner",
        "rotate": "radial",
        "fontSize": 12
      },
      "data": [],
      "itemStyle": {
        "borderWidth": 5,
        "borderRadius": 5
      }
    }
  ]
}
